import { ReactNode } from 'react';

interface WalletSlotProps {
  children: ({ 
    address, 
    connected, 
    connect 
  }: { 
    address: string, 
    connected: boolean, 
    isConnecting: boolean, 
    connect: () => void 
  }) => ReactNode;
}

const WalletSlot: React.FC<WalletSlotProps> = ({ children }: WalletSlotProps) => {
  // const { address, status } = useAccount()

  // const setVisible = useSetAtom(atomWalletModal.visible)
  // const isSigned = useAtomValue(atomWalletModal.isSigned)

  const connectWallet = () => {
    // if (status === 'reconnecting')
    //   return
    // setVisible(true)
  }

  return children({ 
    address: '',
    connected: false,
    isConnecting: false,
    // address, 
    // connected: Boolean(isSigned), 
    // isConnecting: status === 'connecting' || status === 'reconnecting', 
    connect: connectWallet 
  })
};

export default WalletSlot;